import { TWatchAction, WatchActionTypes } from './watchActions';
import { IWatchState } from './watchContext';

export const watchReducer = (state: IWatchState, action: TWatchAction): IWatchState => {
	switch (action.type) {
		case WatchActionTypes.SET_WATCHES:
			return {
				...state,
				watches: action.payload.watches,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case WatchActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case WatchActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				IDSelectedRestaurant: null,
				currentPage: 1,
			};
		case WatchActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				currentPage: 1,
			};
		case WatchActionTypes.TOGGLE_IS_ACTIVE:
			return {
				...state,
				isActive: !state.isActive,
				currentPage: 1,
			};
		case WatchActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				IDSelectedCustomer: null,
				IDSelectedRestaurant: null,
				isActive: false,
				currentPage: 1,
			};
		case WatchActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case WatchActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case WatchActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case WatchActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case WatchActionTypes.SET_ID_FOR_FULL_INFO:
			return {
				...state,
				IDForFullInfo: action.payload.IDForFullInfo,
			};
		case WatchActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case WatchActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		default:
			return state;
	}
};
